import { Box, BoxProps, CircularProgress, Typography } from "@mui/material";

interface PreloaderProps extends Omit<BoxProps, "title"> {
  text?: string;
  title?: string;
}

export const Preloader: React.FC<PreloaderProps> = ({ text, title }) => {
  const hasText = Boolean(text) || Boolean(title);
  return (
    <Box
      sx={{
        left: "50%",
        position: "fixed",
        top: "50%",
        textAlign: "center",
        transform: "translate(-50%,-50%)",
      }}
    >
      <Box sx={{ display: "inline-block", mb: hasText ? 4 : 0 }}>
        <CircularProgress size={24} />
      </Box>
      {title && (
        <Typography
          display="block"
          gutterBottom
          align="center"
          variant="subtitle1"
        >
          {title}
        </Typography>
      )}
      {text && (
        <Typography
          align="center"
          color="text.secondary"
          display="block"
          variant="caption"
        >
          {text}
        </Typography>
      )}
    </Box>
  );
};
